"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDeleteDisciplineFormToPayloadDataHandler = addDeleteDisciplineFormToPayloadDataHandler;
function addDeleteDisciplineFormToPayloadDataHandler(data) {
    return {
        form: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (data.SN && { SN: data.SN })), (data.PT && { PT: data.PT })), (data.OT && { OT: data.OT })), (data.SLP && { SLP: data.SLP })), (data.MSW && { MSW: data.MSW })), (data.HHA && { HHA: data.HHA })), (data.frequencyForAide && { frequencyForAide: data.frequencyForAide })), (data.RD && { RD: data.RD })), (data.notes && { comments: data.notes })),
    };
}
